module.exports = __webpack_public_path__ + "static/plain-cuff-hoop-zircon-heart-cuff-hoop-0538495eb251863c25c888bce6652579.jpg";